const buildMemberProfiles = (groups = []) => {
  const map = {};
  groups.forEach((section) => {
    const members =
      section && Array.isArray(section.members) ? section.members : [];
    members.forEach((member) => {
      if (!member || !member.slug) return;
      const detail = member.profile || {};
      map[member.slug] = {
        slug: member.slug,
        name: member.name || detail.name || '',
        title: member.title || detail.title || '',
        image: member.image || '',
        summary: detail.summary || detail.description || '',
        affiliation: detail.affiliation || null,
        bio: Array.isArray(detail.bio) ? detail.bio : [],
        contacts: Array.isArray(detail.contacts) ? detail.contacts : [],
      };
    });
  });
  return map;
};

export default buildMemberProfiles;
